import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';
import { homeFeatureCards } from './navConfig';

// "O que você quer descobrir?" — 6 shortcut cards displayed under the hero on Home.
// Mobile: 2 cols, Desktop: 3 cols. Uses subtle pastel gradients per card.
const FeatureCards = () => {
  const navigate = useNavigate();

  return (
    <section
      className="px-4 py-10 md:py-14 bg-white"
      data-testid="home-feature-cards"
      aria-labelledby="feature-cards-heading"
    >
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-6 md:mb-8">
          <h2
            id="feature-cards-heading"
            className="text-lg md:text-2xl font-black text-[#0F1C2E] tracking-tight"
          >
            O que você quer descobrir?
          </h2>
          <p className="text-sm text-[#475569] mt-1">
            Explore os dados públicos que a gente organizou pra você.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
          {homeFeatureCards.map((card) => {
            const Icon = card.icon;
            return (
              <button
                key={card.path}
                type="button"
                onClick={() => navigate(card.path)}
                data-testid={card.testId}
                className={cn(
                  'group relative text-left rounded-xl border border-[#E2E8F0] bg-gradient-to-br',
                  card.tone,
                  'p-4 md:p-5 transition-all duration-200',
                  'hover:border-[#006030] hover:shadow-md hover:-translate-y-0.5',
                  'focus:outline-none focus:ring-2 focus:ring-[#006030]/40',
                )}
              >
                <div className="flex items-start justify-between mb-3">
                  <div className="w-10 h-10 md:w-11 md:h-11 rounded-lg bg-white/80 backdrop-blur-sm flex items-center justify-center shadow-sm">
                    <Icon className="w-5 h-5 md:w-6 md:h-6 text-[#006030]" />
                  </div>
                  <ChevronRight className="w-4 h-4 text-[#94A3B8] group-hover:text-[#006030] group-hover:translate-x-0.5 transition-all" />
                </div>
                <h3 className="text-sm md:text-base font-bold text-[#0F1C2E] leading-tight">
                  {card.title}
                </h3>
                <p className="text-[11px] md:text-xs text-[#475569] mt-1 leading-snug">
                  {card.subtitle}
                </p>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeatureCards;
